<template>
  <div class="makeup-exam-management">
    <el-card class="makeup-exam-card">
      <div slot="header" class="card-header">
        <span>补考管理</span>
      </div>

      <!-- 筛选区域 -->
      <div class="filter-container">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-input v-model="filterForm.studentName" placeholder="输入学生姓名"></el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="filterForm.id" placeholder="输入补考ID"></el-input>
          </el-col>
          <el-col :span="9">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-col>
        </el-row>
      </div>
      
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="filteredData"
          style="width: 100%"
          border
          highlight-current-row
        >
          <el-table-column prop="makeupId" label="补考id" width="80" />
          <el-table-column prop="studentId" label="学生id" width="100" />
          <el-table-column prop="studentName" label="学生姓名" width="120" />
          <el-table-column prop="itemId" label="项目id" width="100" />
          <el-table-column prop="originalActivityId" label="原活动id" width="100" />
          <el-table-column prop="makeupDate" label="补考时间" width="150">
            <template #default="scope">
              {{ formatDate(scope.row.makeupDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间" width="150">
            <template #default="scope">
              {{ formatDate(scope.row.applyTime) }}
            </template>
          </el-table-column>
          <el-table-column label="审批老师id" min-width="120">
              <template #default="scope">
                {{ scope.row.approverId || '-' }}
              </template>
            </el-table-column>
          <el-table-column label="补考原因" min-width="200">
              <template #default="scope">
                <div class="content-truncate" :title="scope.row.reason">
                  {{ scope.row.reason || '-' }}
                </div>
              </template>
            </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag
              v-if="scope.row.status === '未审批' || scope.row.status === '待审批'"
              type="warning"
            >
              未审批
            </el-tag>
            <el-tag
              v-else-if="scope.row.status === '已批准' || scope.row.status === '已通过'"
              type="success"
            >
              已批准
            </el-tag>
            <el-tag
              v-else-if="scope.row.status === '已拒绝'"
              type="danger"
            >
              已拒绝
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="text" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button 
              type="text" 
              danger 
              @click="handleDelete(scope.row)"
              v-if="scope.row.status !== '已完成'"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    
    <!-- 编辑对话框 -->
    <el-dialog
      v-model="editDialogVisible"
      title="编辑补考记录"
      width="600px"
      destroy-on-close
    >
      <el-form ref="editFormRef" :model="editForm" label-width="100px" :rules="editRules">
        <el-form-item label="补考id" prop="makeupId">
          <el-input v-model="editForm.makeupId" disabled></el-input>
        </el-form-item>
        <el-form-item label="学生id" prop="studentId">
          <el-input v-model="editForm.studentId" disabled></el-input>
        </el-form-item>
        <el-form-item label="学生姓名" prop="studentName">
          <el-input v-model="editForm.studentName" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目id" prop="itemId">
          <el-input v-model.number="editForm.itemId" disabled></el-input>
        </el-form-item>
        <el-form-item label="原活动id" prop="originalActivityId">
          <el-input v-model.number="editForm.originalActivityId" disabled></el-input>
        </el-form-item>
        <el-form-item label="补考时间" prop="makeupDate">
          <el-date-picker
            v-model="editForm.makeupDate"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="选择补考时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="审批老师id" prop="approverId">
          <el-input v-model.number="editForm.approverId"></el-input>
        </el-form-item>
        <el-form-item label="补考原因" prop="reason">
          <el-input
            v-model="editForm.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入补考原因"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option label="未审批" value="未审批"></el-option>
            <el-option label="已批准" value="已批准"></el-option>
            <el-option label="已拒绝" value="已拒绝"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存修改</el-button>
      </template>
    </el-dialog>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/utils/request';

// 响应式数据
const loading = ref(false);
const currentPage = ref(1);
const pageSize = ref(10);
const totalCount = ref(0);
const editDialogVisible = ref(false);
const editForm = ref({});
const editFormRef = ref(null);

// 表单验证规则
const editRules = {
  status: [
    { required: true, message: '请选择状态', trigger: 'change' }
  ]
};

// 筛选条件
const filterForm = reactive({
  studentName: '',
  id: ''
});

// 补考数据 - 将通过API获取
const makeupExams = ref([]);

// 计算属性 - 过滤后的数据
const filteredData = computed(() => {
  return makeupExams.value;
});

// 格式化日期
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleString('zh-CN');
};

// 搜索处理
const handleSearch = () => {
  currentPage.value = 1; // 重置到第一页
  fetchMakeupExams(); // 重新获取数据
};

// 重置筛选
const resetFilter = () => {
  filterForm.studentName = '';
  filterForm.id = '';
  currentPage.value = 1;
  fetchMakeupExams(); // 重新获取数据
};

// 编辑记录
const handleEdit = (row) => {
  // 深拷贝数据，避免直接修改原数据
  editForm.value = JSON.parse(JSON.stringify(row));
  // 格式化日期以便日期选择器正确显示
  if (editForm.value.makeupDate) {
    editForm.value.makeupDate = new Date(editForm.value.makeupDate).toISOString().slice(0, 19).replace('T', ' ');
  }
  editDialogVisible.value = true;
};

// 保存修改
const handleSave = async () => {
  try {
    // 表单验证
    await editFormRef.value.validate();
    
    // 准备请求数据，只包含后端需要的字段
    const updateData = {
      status: editForm.value.status,
      reason: editForm.value.reason,
      makeupDate: editForm.value.makeupDate,
      approverId: editForm.value.approverId
    };
    
    // 调用API更新数据
    const response = await request.put(`/admin/makeup-exams/${editForm.value.makeupId}`, updateData);
    
    if (response.code === 200 || response.message === '更新成功') {
      ElMessage.success('修改成功');
      editDialogVisible.value = false;
      fetchMakeupExams(); // 重新获取数据
    } else {
      ElMessage.error(response.message || '修改失败');
    }
  } catch (error) {
    // 表单验证失败或其他错误
    if (error !== 'cancel') {
      ElMessage.error('保存操作失败');
    }
  }
};

// 删除记录
const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(
      `确定要删除补考记录 ID: ${row.makeupId} 吗？`,
      '警告',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );
    
    // 调用API删除
    const response = await request.delete(`/admin/makeup-exams/${row.makeupId}`);
    
    if (response.code === 200) {
      ElMessage.success('删除成功');
      fetchMakeupExams(); // 重新获取数据
    } else {
      ElMessage.error(response.message || '删除失败');
    }
  } catch (error) {
    // 用户取消删除或其他错误
    if (error.message !== 'cancel') {
      ElMessage.error('删除操作失败');
    }
  }
};

// 分页处理
const handleSizeChange = (size) => {
  pageSize.value = size;
  fetchMakeupExams();
};

const handleCurrentChange = (current) => {
  currentPage.value = current;
  fetchMakeupExams();
};

// 从API获取补考数据的函数
const fetchMakeupExams = async () => {
  loading.value = true;
  try {
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value
    };
    
    // 添加筛选条件
    if (filterForm.studentName) {
      params.studentName = filterForm.studentName;
    }
    
    if (filterForm.id) {
      params.makeupId = parseInt(filterForm.id);
    }
    
    console.log('获取补考列表参数:', params);
    const response = await request.get('/admin/makeup-exams/list', params);
    
    console.log('获取补考列表响应:', response);
    
    if (response.code === 200 && response.data) {
      // 转换数据格式，确保approverId和reason字段正确显示
      makeupExams.value = (response.data.list || []).map(item => ({
        ...item,
        approverId: item.approverId ? String(item.approverId) : '-',
        reason: item.reason || '-'  
      }));
      totalCount.value = response.data.total || 0;
    } else {
      ElMessage.error(response.message || '获取补考数据失败');
    }
  } catch (error) {
    console.error('获取补考数据异常:', error);
    ElMessage.error('网络错误，请稍后再试');
  } finally {
    loading.value = false;
  }
};

// 组件挂载时从API获取数据
onMounted(() => {
  fetchMakeupExams();
});
</script>

<style scoped>
.makeup-exam-management {
  padding: 10px 0;
}

.makeup-exam-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.table-container {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.content-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>